import { IfStmt } from '@angular/compiler/public_api';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { general } from 'src/app/models/general';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pse-fsv',
  templateUrl: './pse-fsv.component.html',
  styleUrls: ['./pse-fsv.component.css']
})
export class PseFsvComponent implements OnInit {
  public mobile;
  private identity;
  public datosPse = [];
  actual = environment.actual;
  public colorFondo = environment.entidad[this.actual].colorMenu;
  public letraColor = environment.entidad[this.actual].letraColor;
  private items = []
  public total = 0
  public bancos
  public pse: general
  public newPago = false

  private valida1 = false
  private valida2 = false
  private valida3 = false

  constructor(
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    private messageService: MessageService
  ) {
    this.pse = new general()
  }

  ngOnInit(): void {
    this.identity = JSON.parse(this._userService.GetsessionStorage('identity'));
    if (window.screen.width > 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
    this.spinner.show()
    this.getPagos()
  }

  getPagos() {
    let data = {
      codasociado: this.identity.CODASOCIADO
    };
    this._userService.httpPost('getPagos', data).subscribe(resp => {
      if (!this.newPago) {
        this.datosPse = resp.details
        setTimeout(() => {
          this.getPagos()
        }, 5000);
        this.spinner.hide()
      }
    })
  }

  getCartera() {
    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let data = {
      codasociado: this.identity.CODASOCIADO,
      fhasta: year + '-' + (monthIndex + 1) + '-' + day,
      recoge: false,
      pse: true
    };
    this._userService.httpPost('cartera', data).subscribe(
      response => {
        let respuesta = response.details
        console.log(respuesta)
        if (response.status != 'error') {
          for (let i = 0; i < respuesta.length; i++) {
            let cuota = 0
            if (respuesta[i].DIASMORA > 0) {
              cuota = respuesta[i].VALORMORA
            } else {
              cuota = respuesta[i].CUOTA
            }
            let push = {
              pagare: respuesta[i].PAGARE,
              descripcion: respuesta[i].LINEA,
              monto: respuesta[i].MONTO,
              cuota: cuota,
              proxpago: respuesta[i].FHAPROXPAGO,
              servicio: 1
            }
            if (respuesta[i].LINEA != 'TOTALES') {
              this.datosPse.push(push)
            }
          }


          //this.carteraAsociado = response.details;
        } else {
          console.log(response.details)
        }
        //this.spinner.hide()
        this.valida1 = true
      },
      error => {
        console.log(<any>error);
        //this.spinner.hide()
        this.valida1 = true
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ha ocurrido un error, por favor intente más tarde' });
      }
    );
  }

  consultarServicios() {
    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let data = {
      codasociado: this.identity.CODASOCIADO,
      fhasta: year + '-' + (monthIndex + 1) + '-' + day
    };
    this._userService.httpPost('servicios', data).subscribe(
      response => {
        // console.log(response)
        console.log(response.details)
        let respuesta = response.details
        if (response.status != 'error') {

          for (let i = 0; i < respuesta.length; i++) {
            let push = {
              pagare: respuesta[i].CONTRATO,
              descripcion: respuesta[i].LINEA,
              monto: respuesta[i].MONTO,
              cuota: respuesta[i].CUOTA,
              proxpago: respuesta[i].FHAPROXPAGO,
              servicio: 11
            }
            if (respuesta[i].LINEA != 'TOTALES') {
              this.datosPse.push(push)
            }
          }
          console.log(this.datosPse)

          //this.serviciosAsociado = response.details;
        } else {
          console.log(response.details)
        }
        this.valida2 = true
      },
      error => {
        console.log(<any>error);
        this.valida2 = true
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ha ocurrido un error, por favor intente más tarde' });
      }
    );
  }

  getBancos() {
    this._userService.httpGet('bancosPse').subscribe(resp => {
      this.bancos = resp.details
      this.valida3 = true
    }, error => {
      this.valida3 = true
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ha ocurrido un error, por favor intente más tarde' });
    })
  }

  act(item, event) {
    if (event.checked) {
      this.items.push(item)
      this.total = this.total + item.cuota
    } else {
      let itemsArray = this.items
      this.items = []
      this.total = 0
      itemsArray.forEach(item1 => {
        if (item1.pagare != item.pagare) {
          this.items.push(item1)
          this.total = this.total + item1.cuota
        }
      })
    }
  }

  pseSubmit() {
    console.log('pagando')
    this.spinner.show()
    this.pse['items'] = this.items
    this.pse['identity'] = this.identity
    this.pse['total'] = this.total
    this._userService.getIPAddress().subscribe(resp => {
      this.pse['ip'] = resp['ip']
      this._userService.httpPost('pse', this.pse).subscribe(resp => {
        console.log(resp)
        if (resp.status) {
          if (resp.details.status) {
            window.open(resp.details.urlBanco);
            this.getPagos()
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: resp.details.message });
          }
          this.spinner.hide()
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: resp.details.message });
          this.spinner.hide()
        }
      })
    })
  }

  hideSpinner() {
    if (this.valida1 && this.valida2 && this.valida3) {
      this.spinner.hide()
    } else {
      setTimeout(() => {
        this.hideSpinner()
      }, 100);
    }
  }

  nuevoPago() {
    this.spinner.show()

    let data = {
      codunico: this.identity.CODUNICO
    }
    this._userService.httpPost('validaDatosPSE', data).subscribe(resp => {
      if (resp.status) {
        this.newPago = true
        this.datosPse = []
        this.getCartera()
        this.consultarServicios()
        this.getBancos()
        this.hideSpinner()
      }else{
        this.messageService.add({severity: 'error', detail: resp.message, sticky: true})
      }
    })
  }

}
